import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';

// FontAwesome regular (outlined) search icon. Wrapped to match the
// component-with-no-props contract NavIcon expects.
const StyledIcon = styled(FontAwesomeIcon)`
  height: 16px;
  width: 16px;
`;

export default function Search() {
  return <StyledIcon icon={faSearch} />;
}
